import { createContext } from 'react';

/**
 * Selection for the live2 board.
 *
 * `journeyId` is the document id in BOTH collections and the only thing needed to
 * address a journey. `routeId` and `lineCode` are carried for display only:
 * route_id is the train number operators recognise ("7624"), whereas journey_id
 * is "20260813-11e260f7-…" and is unusable as a label. Keeping both in the
 * selection avoids a component having to re-read the document just to render a
 * heading.
 *
 * Deliberately separate from Context.tsx: the old board's Selected is
 * {lineId, routeId} where routeId is the document id, which is not
 * interchangeable with this one.
 */
export type Selected2 = {
  journeyId: string;
  routeId: string | null;
  lineCode: string;
};

type Context2Type = {
  selected: Selected2 | null;
  setSelected: (sel: Selected2 | null) => void;
};

export const Context2 = createContext({} as Context2Type);
